export const lead =
  "I'm a full stack engineer, entrepreneur, and builder who enjoys turning ideas into products people actually use."

export const bio = [
  "Over the past decade I've worn a lot of hats — developer, founder, designer, photographer, and product owner. Before transitioning fully into software engineering, I founded a fashion brand that grew into more than 110 retail locations across the U.S., Canada, Japan, and Australia, with ecommerce eventually making up the majority of the business. That experience still shapes how I build software today: technology should solve real business problems and create better experiences for users.",
  "Professionally, I've worked across ecommerce, healthcare, education, AI, and web3. My work has ranged from enterprise Shopify implementations and Salesforce integrations to internal tools, custom APIs, subscription systems, and customer-facing applications. I've built products using React, TypeScript, .NET, Node.js, Shopify, Azure, and a growing collection of technologies that seemed like a good idea to learn at the time.",
  "I enjoy the messy problems that live between systems — tracking down production issues, designing integrations, improving customer journeys, and figuring out why data isn't ending up where it's supposed to.",
]

export const highlights = [
  {
    value: '110+',
    label: 'retail doors from founder days',
  },
  {
    value: '$40M+',
    label: 'revenue impact from ecommerce work',
  },
  {
    value: '10+',
    label: 'years building brands, sites, and software',
  },
  {
    value: '∞',
    label: 'weird integration issues debugged',
  },
]

export const skills = {
  Frontend: [
    'HTML5',
    'CSS3',
    'JavaScript',
    'TypeScript',
    'React',
    'Liquid',
    'Tailwind CSS',
    'Material UI',
    'Bootstrap',
    'Three.js',
    'Ethers.js',
  ],
  Backend: [
    'Node.js',
    'Express',
    '.NET',
    'Rust',
    'Ruby',
    'GraphQL',
    'PostgreSQL',
    'MongoDB',
    'Google Firebase',
    'Solidity',
    'Hardhat',
    'IPFS',
  ],
  Ecommerce: [
    'Shopify Plus',
    'Admin API',
    'Storefront API',
    'Checkout UI Extensions',
    'Shopify Functions',
    'Cart Scripts (Ruby)',
    'Klaviyo',
    'Recharge',
    'Rebuy',
    'Yotpo',
    'Octane AI',
  ],
  'Cloud & Tools': [
    'Claude',
    'OpenAI APIs',
    'AWS',
    'Google Cloud',
    'Azure',
    'Ubuntu',
    'GitHub',
    'Figma',
    'Photoshop',
  ],
}

export const outside = `Outside of work, you can usually find me in the waves or on the slopes, building side projects, experimenting with AI, making music, or tinkering with retro gaming hardware. I'm naturally curious and tend to fall down technical rabbit holes that begin as "just a quick idea" and somehow turn into full projects. At the end of the day, I enjoy taking ideas from concept to reality and learning something new in the process.`
